import { experiments, useExperiment } from "@/utils/experiment";

import { Cfind1192SignupForm } from "./free/variants/cfind-1192-button-resize/cfind-1192-button-resize";
import { CobrandedLoggedOutForm } from "./free/variants/cobranded-logged-out-form";

export const LoggedOutConfluenceFree = () => {
    const cfind1192SignupButtonResize = useExperiment(
        experiments.cfind1192SignupButtonResize
    );

    if (cfind1192SignupButtonResize.type === "enrolled") {
        cfind1192SignupButtonResize.fireExposure();

        if (cfind1192SignupButtonResize.value) {
            return <Cfind1192SignupForm />;
        }
    }

    return (
        <div data-testid="logged-out-confluence-free">
            <CobrandedLoggedOutForm />
        </div>
    );
};
